<template>
  <div
    class="item_content accordion_content"
  >
    <!-- S : 제품정보 리스트 -->
    <div class="product_list_wrap">
      <template v-for="productGroup in productsByGroup">
        <div
          :key="productGroup.name"
          class="daily_item  width_full_type"
        >
          <p>{{ productGroup.name }}</p>
          <ul class="smallImg_list">
            <template v-for="product in productGroup.items">
              <final-applied-item-info-detail-item
                v-if="product.count > 0"
                :key="product.item_sku"
                :product="product"
              />
            </template>
          </ul>
        </div>
      </template>
    </div>
    <!-- E : 제품정보 리스트 -->
  </div>
</template>

<script>
import FinalAppliedItemInfoDetailItem from './FinalAppliedItemInfoDetailItem.vue';

export default {
  name: 'FinalAppliedItemInfoDetail',
  components: {
    FinalAppliedItemInfoDetailItem,
  },
  props: {
    productsByGroup: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
